import React, {useRef} from 'react'
import PropTypes from 'prop-types';
import styles from './Input.module.css';
import { Col } from 'antd';

const Input = (props) => {
  const {
    label,
    placeholder,
    isDisabled,
    inputType, 
    isError,
    isErrorText,
    isInfo, 
    name,
    colspan,
    elementtype,
    value,
    flex,
    ...etc
  } = props;
  return (
    <Col xl={colspan} span={24} flex={flex}>
      <div className={styles.formWrapper}>
        <label className={styles.formLabel}>{label}</label>
        <div className={styles.inputWrapper}>
          <input type={inputType} name={name} disabled={isDisabled} className={styles.formControl} placeholder={placeholder} defaultValue={value} />
        </div>
      </div>
    </Col>
  )
}

Input.propTypes = {
  inputType: PropTypes.oneOf(["text", "mail", "phone", "password"]),
  label: PropTypes.string,
  name: PropTypes.string,
  colspan: PropTypes.number,
  placeholder: PropTypes.string,
  isDisabled: PropTypes.bool,
  isError: PropTypes.bool, 
  isErrorText: PropTypes.string, 
  elementtype: PropTypes.string, 
};

Input.defaultProps = {
  inputType: "text",
  label: 'Adınız Soyadınız',
  name: null,
  colspan: null,
  placeholder: 'Giriniz',
  isDisabled: false,
  isError: false, 
  isErrorText: null, 
  elementtype: null, 
};

export default Input